import { Locale } from 'vue-i18n';
import { UpdateUserInput, Language, _Boolean } from '@/API';
import { updateUserWithConnection } from '@/appsync/graphql/user';
import { graphqlQuery } from '@/appsync/service/GraphqlUtils';
import { LoginInfo } from '@/types/type';

const update = async (input: UpdateUserInput): Promise<void> => {
  await graphqlQuery(updateUserWithConnection, { input });
};

export interface UpdateLanguageParam extends LoginInfo {
  language: Locale;
}

export const updateLanguage = async (
  param: UpdateLanguageParam
): Promise<void> => {
  const { tenant, landscape, loginName } = param;
  const language = param.language as Language;
  await update({ tenant, landscape, loginName, language });
};

export interface UpdateUsageFavorite extends LoginInfo {
  usage: boolean;
}

export const updateUsageFavorite = async (
  param: UpdateUsageFavorite
): Promise<void> => {
  const { tenant, landscape, loginName } = param;
  const displaysFavoritePanel = param.usage ? _Boolean._true : _Boolean._false;
  await update({ tenant, landscape, loginName, displaysFavoritePanel });
};
